import type { FC, ReactNode, SVGProps } from 'react'

// The four-pointed ✦ star used across the site, drawn as a vector so it scales and takes currentColor.
export const SPARKLE_PATH = 'M12 0C12.9 7.4 16.6 11.1 24 12C16.6 12.9 12.9 16.6 12 24C11.1 16.6 7.4 12.9 0 12C7.4 11.1 11.1 7.4 12 0Z'

const Sparkle: FC<SVGProps<SVGSVGElement>> = (props): ReactNode => {
    return (
        <svg viewBox='0 0 24 24' aria-hidden='true' focusable='false' {...props}>
            <path d={SPARKLE_PATH} fill='currentColor' />
        </svg>
    )
}

export default Sparkle
